module.exports = __webpack_public_path__ + "img/only_cake.95f195c6.png";